export default [
  'Small',
  'Mid-Market',
  'Enterprise'
]


// WEBPACK FOOTER //
// ./src/scripts/constants/DemandbaseEmployeeRanges.js